// Shopfront details for each venue, shown in the info box under the roster tabs.
//
// Deliberately static rather than scraped. These change very rarely, and scraping
// contact details across two different site templates would add another brittle
// selector path and another silent-failure mode for no real benefit.
//
// Every value below was read off the venue's own website (September 2026):
//   - No 5 Marrickville   : no5marrickville.com (footer + tel: link)
//   - The Nightshade      : thenightshade.com.au (footer)
//   - Ginza Club          : ginzaclub.com.au <address> + /en/g/<id> JSON `phone`
//   - Ginza Empire        : 479ginza.com.au <address> + /en/g/<id> JSON `phone`
//
// NOTE on the Ginza pair: both sites share one footer listing BOTH venues, plus a
// shared landline (02 7901 3000). The per-venue mobile numbers below come from the
// `phone` field of each site's own performer JSON, which is venue-specific. Don't
// "fix" them by copying whatever the footer shows first.
//
// If a venue changes address or number, update it here - nothing else reads it.

export const VENUE_INFO = {
  marrickville: {
    name: "No 5 Marrickville",
    website: "https://no5marrickville.com",
    address: "5 Gerald Street, Marrickville NSW 2204",
    phone: "0417 888 123",
    phoneDial: "+61417888123",
  },
  cleveland: {
    name: "Ginza Club",
    website: "https://www.ginzaclub.com.au",
    address: "310 Cleveland Street, Surry Hills NSW 2010",
    addressNote: "Back entrance from Goodlet Lane",
    phone: "0488 888 310",
    phoneDial: "+61488888310",
    hours: "10:30am – 2am, open 7 days",
  },
  elizabeth: {
    name: "Ginza Empire",
    website: "https://www.479ginza.com.au",
    address: "479 Elizabeth Street, Surry Hills NSW 2010",
    addressNote: "Back entrance from Little Buckingham Street",
    phone: "0416 020 278",
    phoneDial: "+61416020278",
  },
  gladesville: {
    name: "The Nightshade Establishment",
    website: "https://thenightshade.com.au",
    address: "2/42 Buffalo Road, Gladesville NSW 2111",
    phone: "0498 100 011",
    phoneDial: "+61498100011",
  },
};

// Google's documented, stable "search by query" URL. Preferred over copying a
// venue's own deep map link, which embeds place ids that can go stale.
export function mapsUrl(address) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

export function getVenueInfo(venue) {
  return VENUE_INFO[venue] || null;
}
